import { z } from "zod";

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png"];

export const mentorProfileSchema = z.object({
  description: z.string().min(1, "Заполните описание"),
  image: z
    .instanceof(File)
    .refine((file) => file.size <= MAX_FILE_SIZE, "Максимальный размер 5MB")
    .refine(
      (file) => ALLOWED_IMAGE_TYPES.includes(file.type),
      "Файл должен быть в формате JPEG или PNG",
    )
    .optional(),
});

export type MentorProfileForm = z.infer<typeof mentorProfileSchema>;
